import { Controller } from 'stimulus'

export default class extends Controller {
  connect() {
    this._eventsToStop = this.data.get('events').split(' ')
    this._stoppedAttr = this.data.get('stopEventsAttribute')

    console.log(this._eventsToStop, this._stoppedAttr)
    this._eventsToStop.forEach((event) => {
      this.element.addEventListener(event, this.stop_event.bind(this), { capture: true })
    })
  }

  disconnect() {
    this._eventsToStop.forEach((event) => {
      this.element.removeEventListener(event, this.stop_event.bind(this), { capture: true })
    })
  }

  stop_event(event) {
    console.log('triggered stop event')
    if (event.currentTarget.hasAttribute(this._stoppedAttr)) {
      event.stopPropagation()
      console.log('STOPPED!!', event)
    }
  }
}
